import React from 'react';
import { Button, Flex, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { CustomButton } from '@/components';

interface CustomDeleteModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  confirmColor?: string;
  width?: number;
  height?: number;
  titleFontSize?: number;
  messageFontSize?: number;
  messageIcon?: React.ReactNode;
  titleMargin?: string;
  titleGap?: string;
  actionsGap?: number;
  buttonHeight?: number | string;
  closeIconSize?: number | string;
  disableConfirmBtn?: boolean;
  addButton?: React.ReactNode;
}

const CustomDeleteModal: React.FC<CustomDeleteModalProps> = ({
  visible,
  onClose,
  onConfirm,
  title,
  message,
  cancelText,
  confirmText,
  confirmColor,
  width = 542,
  height = 184,
  titleFontSize = 24,
  messageFontSize = 14,
  messageIcon,
  titleMargin = '0',
  titleGap = '12px',
  actionsGap = 12,
  buttonHeight = 40,
  closeIconSize = 16,
  disableConfirmBtn = false,
  addButton,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      zIndex={2000}
      width={width}
      style={{ minHeight: height, borderRadius: '16px' }}
      className='custom-delete-modal'
    >
      <Flex
        justify='space-between'
        align='center'
        style={{ marginBottom: titleGap }}
      >
        <h3
          style={{
            fontSize: titleFontSize,
            fontWeight: 'bold',
            margin: titleMargin,
          }}
        >
          {title}
        </h3>
        <CloseOutlined
          style={{
            fontSize: closeIconSize,
            cursor: 'pointer',
            alignSelf: 'flex-start',
          }}
          onClick={onClose}
        />
      </Flex>

      <Flex align='center' gap={8} style={{ marginBottom: '20px' }}>
        {messageIcon && <span>{messageIcon}</span>}
        <div
          style={{
            fontSize: messageFontSize,
            color: 'var(--text-primary)',
            width: '100%',
          }}
        >
          {message}
        </div>
      </Flex>
      <Flex justify='end' gap={actionsGap}>
        {addButton && <span>{addButton}</span>}
        {cancelText && (
          <Button
            type='text'
            onClick={onClose}
            style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--text-primary)',
              height: buttonHeight,
            }}
          >
            {cancelText}
          </Button>
        )}

        {confirmText && (
          <CustomButton
            isFormValid={disableConfirmBtn}
            text={confirmText}
            onClick={onConfirm}
            height={buttonHeight}
            bgColor={confirmColor}
            border={confirmColor}
            fontSize='14px'
            fontWeight={600}
            borderRadius='8px'
            padding='10px 12px'
          />
        )}
        {/* {confirmText && (
          <Button
            type='primary'
            danger
            onClick={onConfirm}
disabled
            style={{
              height: buttonHeight,
              backgroundColor: confirmColor,
              borderColor: confirmColor,
              fontSize: '14px',
              fontWeight: '600',
              padding: '10px 12px',
              borderRadius: '8px',
            }}
          >
            {confirmText}
          </Button>
        )} */}
      </Flex>
    </Modal>
  );
};

export default CustomDeleteModal;
